import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import {
  Badge
} from "reactstrap";
import { MdDelete } from "react-icons/md";
import Button from "../Form/Button";
import Img from "../Img";

import styles from "./Channel.module.scss";
import { channelTypes, channelStatus, channelCountries } from "./constants";


const Channel = props => {
  const { channel, className, onDelete, actions, noLink, coverSize = 80, ...rest } = props;
  const handleDelete = e => {
    e.preventDefault();
    e.stopPropagation();
    var confirmDelete = window.confirm(`کانال ${channel.name} برای همیشه حذف خواهد شد.`)
    if (confirmDelete) onDelete(channel)
  }
  if(!channel) return null;
  return (
    <div {...rest} className={classNames('text-dark d-flex align-items-center position-relative', className, { disabled: channel.wait })}>
      {!noLink && <Link to={`/channels/${channel.id}`} className={styles.channelLink}>{channel.name}</Link>}

      <Img src={`${channel.picture || channel.cover}/r/${2 * coverSize}x${2 * coverSize}`} width={coverSize} height={coverSize} fill="#ccc" className={classNames("rounded ml-3", { 'disabled': channel.status === 'INACTIVE' })} />

      <div className="d-flex flex-column align-items-start justify-content-center">
        <h6>
          {channel.name}
        </h6>

        <div className="d-flex align-items-center">
          <Badge className="ml-3" color="light">{channelTypes[channel.type].label}</Badge>
          {!!channel.startPoint && <Badge className="ml-3">با نقطهٔ شروع</Badge>}
          {
            Object.keys(channelStatus).map(status => {
              if (status !== channel.status) return null;
              return (
                <Badge key={status} color={channelStatus[status].color} className="ml-3">{channelStatus[status].label}</Badge>
              )
            })
          }
          {
            Object.keys(channelCountries).map(country => {
              if (country !== channel.country) return null;
              return (
                <Badge key={country} color={channelCountries[country].color || 'info'} className="ml-3">{channelCountries[country].label}</Badge>
              )
            })
          }
        </div>
      </div>
      {actions && <div className={classNames("mr-auto", styles.actions)}>
        <Button
          color="danger"
          outline
          className={classNames({ "has-icon": !channel.wait })}
          onClick={handleDelete}
          loading={channel.wait}
        >
          <MdDelete />
        </Button>
      </div>
      }
    </div>
  )
}

export default Channel;